import * as React from 'react';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { getMSID } from '../../authfile';
import AppInsight from '../Azure/AppInsights';

export default function CustomizedSnackbars({type, message, API}) {
  const [open, setOpen] = React.useState(true);
  const msid = getMSID();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  React.useEffect(() => {
    if(type === "error"){
        AppInsight.trackEvent({ name: `RQA => ${API} Error, msid=> ${msid}`, properties: { errorMessage: message } });
    }
  },[])

  return (
    <div>
      <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={type}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
}
